import React from "react";
import {defaultPageConfig, ExtraRegistrationFields, Page, PageConfig} from "/src/domain/shared/Page";

import '../../i18n';

import {UserRole} from "/src/domain/shared/User";

import {mountComponentToContainer} from "/src/domain/shared/mountUtils";

import {
    ChallengeRegistrationData,
    Currency,
    RegistrationStatus
} from "/src/domain/challenges/ChallengeRegistrationData";
import {ChallengeUser} from "/src/domain/challenges/ChallengeUser";
import ChallengeRegistrationApp from "/src/ui/challengesRegistration/ChallengeRegistrationApp";
import {ChallengeFormula} from "/src/domain/challenges/ChallengeProtocolData";

window.mountPage = mountPage;

function mountPage(page: Page, pageData: ChallengeRegistrationData, currentUser?: ChallengeUser, pageConfig?: PageConfig) {
    if (page !== Page.CHALLENGES_REGISTRATION) {
        console.error('Unknown page type');
        return;
    }

    mountComponentToContainer(page, pageData, currentUser, pageConfig ? pageConfig : defaultPageConfig, ChallengeRegistrationApp)
}

// mountPage(Page.CHALLENGES_REGISTRATION, {
//     startreg: 0,
//     locationDescription: "Второй этап Кубка S10 с очень интересным описанием и советами, как не накосячить с регистрацией в локациях",
//     locations: [
//         // "Бегу онлайн", "Сестрорецк"
//     ],
//     name: "Кубок S10.run. Второй этап \"Весенний Призыв\"",
//     startPackOptions: [],
//     payment: {
//         status: RegistrationStatus.NEW,
//         error: null,
//         options: {
//             [Currency.EUR]: [
//                 {label: 'challenge_entry_fee', price: 1}
//             ],
//             [Currency.RUB]: [
//                 {label: 'challenge_entry_fee', price: 1000}
//             ]
//         },
//         currency: Currency.EUR,
//         paymentUrl: {
//             [Currency.EUR]: "https://stripe.com/checkout",
//             [Currency.RUB]: "https://tinkoff.com/checkout"
//         }
//     },
//     isActive: true,
//     challengeKey: 'asdasd',
//     isPaid: true,
//     teamRegistration: {
//         maxTeamParticipants: 2,
//         minTeamParticipants: 2,
//         teams: [
//             {
//                 id: 1,
//                 teamCode: '123',
//                 name: "Team 1",
//                 participants: [{firstName: 'Name', lastName: 'Surname', userId: '123'}, {
//                     firstName: 'Name',
//                     lastName: 'Surname',
//                     userId: '456'
//                 }],
//                 isPrivate: true
//             },
//             {
//                 id: 2,
//                 teamCode: '1234',
//                 name: "Team 2",
//                 participants: [{firstName: 'Name', lastName: 'Surname', userId: '789'}],
//                 isPrivate: true
//             },
//             {
//                 id: 3,
//                 teamCode: '1234',
//                 name: "Team 3",
//                 participants: [{firstName: 'Name', lastName: 'Surname', userId: '789'}],
//                 isPrivate: true
//             },
//         ],
//         isTeamCreator: true,
//         teamKey: 'asdafg'
//     },
//     challenge: {
//         id: 1,
//         formulaType: ChallengeFormula.IPPODROM,
//         minTeamParticipants: 2,
//         maxTeamParticipants: 2,
//         name: "Ипподром",
//         description:
//             "Длинный текст описания забега Длинный текст описания забега Длинный текст описания забега",
//         protocolLink: "https://challenges.s10.run/protocol-team?id=TeOJTz2f3PuO",
//         rulesLink: "https://s10.run/14feb2022",
//         imgUrl:
//             "https://s10-dashboard.routeme.life/static/49928169809e7424d2e6fb2166298482.png",
//     },
// }, {
//     email: "vatrushkinvv@gmail.com",
//     stravaId: "123123123",
//     trainingsRequests: [],
//     currentTrainerId: undefined,
//     id: "123",
//     isPremium: true,
//     role: UserRole.TRAINER,
//     challengeRegistration: {
//         isRegistered: true,
//         predictions: [/*{
//             km: 10,
//             sec: 3700,
//             pace: 287
//         }*/],
//         // predictionNostra: 7200
//     }
// }, {
//     chatLink: "",
//     isWhiteLabel: false,
//     timestamp: 0,
//     footer: true,
//     header: true,
//     challengesLink: "true",
//     isChallengesLinkDisabled: true,
//     predictions: true,
//     authUrl: '',
//     shopBanner: true,
//     extraFields: [
//         ExtraRegistrationFields.REGION,
//         // ExtraRegistrationFields.CITY, ExtraRegistrationFields.AGE, ExtraRegistrationFields.DISTANCE, ExtraRegistrationFields.FIO,
//         // ExtraRegistrationFields.GENDER, ExtraRegistrationFields.POSITION, ExtraRegistrationFields.UNIT,
//         // ExtraRegistrationFields.PREDICTION
//     ]
//
// });
